import { render, staticRenderFns } from "./SellerProductsList.vue?vue&type=template&id=65a5ef78&"
import script from "./SellerProductsList.vue?vue&type=script&lang=js&"
export * from "./SellerProductsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports